/* agb-slot-polish.js — two small things about the easy-suggestion SLOTS.
 * ─────────────────────────────────────────────────────────────────────────
 * Dorian, 2026-09-07:
 *   "the arrow buttons should be more in the bottom, smaller, not moving the
 *    checkbox not aligned with non slots gearbuilder/easysuggest cards"
 *   "a checkboxed accessorie should make its corresponding dot filled maybe
 *    green or same color than the checkbox (blue) so we know it is activated
 *    without clicking it"
 *
 * A "slot" is a suggestion that has ALTERNATIVES: easy-suggestion-system
 * wraps those cards in .agb-slot > .agb-slot-viewport > .agb-slot-track, and
 * adds its own arrow buttons and a row of dots. A suggestion with only one
 * product has no slot at all - those are the "non slots cards".
 *
 * ── WHY THE ROWS DID NOT LINE UP. Measured on the belt PDP, 2026-09-07:
 *   plain card   padding 12px            -> 66px tall, checkbox 20px from the
 *                                           top AND 20px from the bottom.
 *   slot card    padding 12px 54px 20px 12px -> 74px tall, checkbox 20px from
 *                                           the top but 28px from the bottom.
 * The extra 8px at the bottom is room the system reserves for its dots, and
 * it is the whole of the problem: the card grows downward, so it stands 8px
 * taller than its neighbours and its checkbox is no longer on their centre
 * line. Putting the bottom padding back to 12px fixes the height and the
 * checkbox in one go. The RIGHT padding is deliberately left alone - it is
 * what keeps the price clear of the arrow's column, and nothing was wrong
 * with the horizontal layout (every visible checkbox already sat at x=33).
 *
 * ── NOTHING UPSTREAM IS EDITED. easy-suggestion-system.min.js writes all of
 * this as INLINE styles (measured: the arrow carries `top:50%; right:6px;
 * font:700 40px/1 ...` on the element itself), so there is no stylesheet rule
 * to lose a specificity fight with - only inline, which is why every override
 * here carries !important. This file adds a class and some CSS and reads
 * checkboxes; it never touches the system's markup, its handlers or its cart
 * behaviour. [[feedback_isolation_principle]]
 */
(function () {
  'use strict';
  if (window.__agbSlotPolish) return;
  window.__agbSlotPolish = true;

  // The colour a filled dot takes. One line to change: the brand olive is
  // #92ae74, the oxblood #8f1814. Blue is what he named first, because it is
  // the colour the checkbox itself shows when it is ticked.
  var CHOSEN = '#1a73e8';

  var css = [
    /* the arrow: smaller glyph, and down at the bottom of its column rather
       than floating on the middle of the row. The BOX stays big enough to
       press - the glyph shrinks, the padding keeps a ~32px target. */
    '.agb-slot .agb-slot-arrow{',
    'top:auto !important;bottom:2px !important;transform:none !important;',
    'font-size:20px !important;line-height:1 !important;padding:6px 8px !important;',
    '}',
    /* the card stops growing downward, so a slot row is exactly as tall as a
       plain one and its checkbox sits on the same centre line */
    '.agb-slot .suggestion-card{padding-bottom:12px !important}',
    /* ONE PRICE RAIL DOWN THE LIST (Dorian 2026-09-08: "the prices are still
       not aligned between a product that has several options for a slot (with
       the arrow) and one that is alone on its slot").

       A card inside a slot is given `padding-right:54px` inline, to hold the
       arrow's column clear. A card that is alone in its slot is given nothing,
       so its price sat 42px further right and the column of prices stepped in
       and out down the page. The header of this file says the right padding was
       left alone on purpose - that was right when only the arrow mattered, and
       it is the thing to change now that the prices have to agree.

       Every card in the list takes the same right inset, but ONLY in a list
       that actually holds a slot: where every suggestion is a single option
       there is no arrow anywhere, the rows already agree, and reserving room
       for one would just eat 42px of title. `!important` is required because
       the inline style is written per-card by the script that builds the slots,
       and it also puts back the LAST member of a slot, which that script clears
       on every re-sort. The arrows are untouched, and so is the left side. */
    'ul.suggestions-list:has(.agb-slot-track) .suggestion-card{',
    'padding-right:54px !important;',
    '}',
    /* a ticked alternative fills its own dot, so which one is active is
       readable without opening the slot */
    '.agb-slot .agb-slot-dot.agb-dot-chosen{',
    'background:' + CHOSEN + ' !important;border-color:' + CHOSEN + ' !important;',
    '}'
  ].join('');

  function style() {
    if (document.getElementById('agb-slot-polish-css')) return;
    var el = document.createElement('style');
    el.id = 'agb-slot-polish-css';
    el.textContent = css;
    (document.head || document.documentElement).appendChild(el);
  }

  // Member i of a slot is dot i. The system builds them in the same order and
  // in the same numbers; anything else is a slot mid-rebuild, and skipping it
  // costs one frame.
  function syncSlot(slot) {
    try {
      var members = slot.querySelectorAll('.agb-slot-member');
      var dots = slot.querySelectorAll('.agb-slot-dot');
      if (!dots.length || dots.length !== members.length) return;
      for (var i = 0; i < dots.length; i++) {
        var cb = members[i].querySelector('.agb-item-checkbox');
        dots[i].classList.toggle('agb-dot-chosen', !!(cb && cb.checked));
      }
    } catch (e) { /* a slot we do not understand is left exactly as it is */ }
  }

  function syncAll() {
    try {
      var slots = document.querySelectorAll('.agb-slot');
      for (var i = 0; i < slots.length; i++) syncSlot(slots[i]);
    } catch (e) { /* never throw into the page */ }
  }

  // A tick can be REFUSED by the system a moment later - it un-checks the box
  // itself when the variant turns out to be unavailable (easy-suggestion-
  // system does this in its own change handler). So the dot is read again
  // just after, rather than trusting the first read.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('agb-item-checkbox')) return;
    var slot = t.closest && t.closest('.agb-slot');
    if (slot) { syncSlot(slot); setTimeout(function () { syncSlot(slot); }, 400); }
  }, true);

  function start() {
    style();
    syncAll();
    try {
      var host = document.querySelector('.suggestions-list, .product-suggestion') || document.body;
      new MutationObserver(function () { syncAll(); })
        .observe(host, { childList: true, subtree: true });
    } catch (e) { /* no observer: the change listener still carries it */ }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  // the system builds its cards from a fetch, so the first paint can be late
  setTimeout(syncAll, 1200);
  setTimeout(syncAll, 3000);
}());
